var ExpandTrigger;
(function(ExpandTrigger2) {
  ExpandTrigger2["CLICK"] = "click";
  ExpandTrigger2["HOVER"] = "hover";
})(ExpandTrigger || (ExpandTrigger = {}));
const CASCADER_PANEL_INJECTION_KEY = Symbol();

export { CASCADER_PANEL_INJECTION_KEY, ExpandTrigger };
//# sourceMappingURL=types.mjs.map
